import React, { useState, useMemo, useEffect } from "react";
import {
  Box,
  useTheme,
  Typography,
  Autocomplete,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import { getAvisoInfo, getAvisosOperador, getServicios } from "../../services";
import { generateAndDownloadPDF } from "../../utils/pdfHelper";
import useMediaQuery from "@mui/material/useMediaQuery";
import { dataGridStyles } from "../../styles/styles";
import { FaCheck, FaTimes, FaFileDownload } from "react-icons/fa";
import moment from "moment/moment";
import "moment/locale/es";
import { useSelector } from "react-redux";
import { availableYears } from "../../data/staticData";
// import { RiFolderDownloadFill } from "react-icons/ri";
// import { PiFileMagnifyingGlassFill } from "react-icons/pi";
// import { MdImageNotSupported } from "react-icons/md";
//getDocsAviso

const ConsultaAvisos = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery("(min-width: 600px)");

  const [listaAvisos, setListaAvisos] = useState([]);
  const usuarioSitae = useSelector((state) => state.user);
  const [tipoServicio, setTipoServicio] = useState([]);
  //const [archivos, setArchivos] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [loading, setLoading] = useState(false);
  const [impersonatedUser, setImpersonatedUser] = useState("");

  const isAdmin = usuarioSitae === "AT0001";
  const effectiveUser = isAdmin && impersonatedUser.trim() ? impersonatedUser.trim() : usuarioSitae;

  const columnsAvisos = useMemo(
    () => [
      {
        field: "id",
        headerName: "Aviso Cobro",
        flex: 1,
        headerAlign: "center",
        align: "center",
        cellClassName: "name-column--cell",
      },
      {
        field: "FechaEmision",
        headerName: "Fecha Emisión",
        flex: 1.5,
        headerAlign: "center",
        align: "center",
        valueFormatter: (params) => moment(params?.value).utc().format("LL"),
      },
      {
        field: "FechaVencimiento",
        headerName: "Fecha Vencimiento",
        flex: 1.5,
        headerAlign: "center",
        align: "center",
        valueFormatter: (params) => moment(params?.value).utc().format("LL"),
      },
      {
        field: "Servicio",
        headerName: "Servicio",
        flex: 2,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "Moneda",
        headerName: "Moneda",
        flex: 1,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "Monto",
        headerName: "Monto",
        flex: 1,
        headerAlign: "center",
        align: "center",
        valueFormatter: (params) => {
          return new Intl.NumberFormat("es-HN", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(parseFloat(params.value));
        },
      },
      {
        field: "EstadoAviso",
        headerName: "Estado Aviso",
        flex: 2,
        headerAlign: "center",
        align: "center",
        renderCell: ({ row: { EstadoAviso } }) => {
          return (
            <Box
              width="100%"
              m="0 auto"
              p="5px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              backgroundColor={
                EstadoAviso === "En Tramite de Pago" ? colors.desert[500] : "#2e7c67"
              }
              borderRadius="4px"
            >
              {EstadoAviso === "En Tramite de Pago" && <FaTimes color="#ffffff" size={16} />}
              {EstadoAviso === "Pagado (Reportado Banco)" && (
                <FaCheck color="#ffffff" size={16} />
              )}
              <Typography sx={{ ml: 1, color: "#ffffff", fontWeight: "bold", fontSize: "0.8rem" }}>
                {EstadoAviso}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: "downloadPDF",
        headerName: "Descargar PDF",
        flex: 2,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => {
          const handleDownload = async () => {
            setLoading(true);
            try {
              const dataAviso = await getAvisoInfo(params.row.id);
              const result = await generateAndDownloadPDF(dataAviso);

              if (!result.success) {
                console.error("Failed to generate PDF:", result.error);
                // TODO: Show error notification to user
              }
            } catch (error) {
              console.error("Error al generar PDF:", error);
            } finally {
              setLoading(false);
            }
          };

          return (
            <Box
              width="100%"
              m="0 auto"
              p="5px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRadius="4px"
            >
              <Button
                variant="contained"
                color="secondary"
                size="small"
                startIcon={!loading && <FaFileDownload />}
                onClick={handleDownload}
                disabled={loading}
              >
                {loading ? <CircularProgress size={20} color="inherit" /> : "Descargar Aviso"}
              </Button>
            </Box>
          );
        },
      },
    ],
    [colors.desert, loading]
  );

  // const columnsDocumentos = useMemo(
  //   () => [
  //     {
  //       field: "id",
  //       headerName: "Id",
  //       flex: 1,
  //       headerAlign: "center",
  //       align: "center",
  //       cellClassName: "name-column--cell",
  //     },
  //     {
  //       field: "Nombre",
  //       headerName: "Nombre",
  //       flex: 3,
  //       headerAlign: "center",
  //       align: "center",
  //     },
  //     // {
  //     //   field: "ImagenData",
  //     //   headerName: "Archivo",
  //     //   flex: 1,
  //     //   headerAlign: "center",
  //     //   align: "center",
  //     //   renderCell: ({ row }) => {
  //     //     const handleDownload = () => {
  //     //       const { ImagenNombre, Data } = row;
  //     //       if (!Data || !Data.data) {
  //     //         console.error("Datos del archivo incompletos.");
  //     //         return;
  //     //       }

  //     //       // Convierte el array de bytes (Buffer) a un Blob
  //     //       const blob = new Blob([new Uint8Array(Data.data)], {
  //     //         type: "application/pdf",
  //     //       }); // Cambia el tipo si no es PDF
  //     //       const url = URL.createObjectURL(blob);

  //     //       // Crea un enlace de descarga
  //     //       const link = document.createElement("a");
  //     //       link.href = url;
  //     //       link.download = ImagenNombre || "archivo.pdf"; // Usa el nombre proporcionado o un valor por defecto
  //     //       link.click();

  //     //       // Limpia el objeto URL
  //     //       URL.revokeObjectURL(url);
  //     //     };

  //     //     return (
  //     //       <Box
  //     //         width="40px"
  //     //         height="40px"
  //     //         m="0 auto"
  //     //         p="5px"
  //     //         display="flex"
  //     //         justifyContent="center"
  //     //         alignItems="center"
  //     //         backgroundColor={
  //     //           row.ImagenNombre === null
  //     //             ? colors.redAccent[700]
  //     //             : colors.grey[800]
  //     //         }
  //     //         borderRadius="4px"
  //     //         sx={{ cursor: "pointer" }} // Cambia el cursor a "pointer" para indicar que es clickeable
  //     //         onClick={handleDownload} // Llama a la función de descarga al hacer clic
  //     //       >
  //     //         <RiFolderDownloadFill size={20} color={colors.grey[100]} />
  //     //       </Box>
  //     //     );
  //     //   },
  //     // },
  //   ],
  //   []
  // );

  const loadForEffectiveUser = async () => {
    const target = isAdmin && impersonatedUser.trim() ? impersonatedUser.trim() : usuarioSitae;
    setSelectedService(null);
    setSelectedYear(null);
    setListaAvisos([]);
    setTipoServicio(await getServicios(target));
  };

  const avisosOperador = async (tipoServicio, anio) => {
    if (!tipoServicio?.value) return;
    const anioFinal = anio && anio.value ? anio.value : new Date().getFullYear();
    setLoading(true);
    setListaAvisos(await getAvisosOperador(effectiveUser, tipoServicio?.value, anioFinal));
    setLoading(false);
  };

  const handleChange = (newValue, field) => {
    if (field === "service") setSelectedService(newValue);
    if (field === "year") setSelectedYear(newValue);

    // Llama a getAvisosOperador con los valores actuales
    avisosOperador(
      field === "service" ? newValue : selectedService,
      field === "year" ? newValue : selectedYear
    );
  };

  // const handleRowClick = async (params) => {
  //   const selectedId = params.row.id;
  //   setArchivos(await getDocsAviso(selectedId));
  // };

  useEffect(() => {
    const fetchData = async () => {
      setTipoServicio(await getServicios(effectiveUser));
    };
    fetchData();
  }, [effectiveUser]);

  return (
    <Box m="5px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="CONSULTAS DE FACTURACIÓN" subtitle="Consulte sus avisos de cobro" />
      </Box>
      <Box
        display="grid"
        gap="20px"
        gridTemplateColumns="repeat(12, minmax(0, 1fr))"
        gridTemplateRows="auto"
        sx={{
          "& > div": { gridColumn: isNonMobile ? undefined : "span 6" },
        }}
      >
        {isAdmin && (
          <Box gridColumn="span 12" display="flex" alignItems="center" gap={2}>
            <TextField
              label="Simular operador (código)"
              variant="filled"
              color="secondary"
              value={impersonatedUser}
              onChange={(e) => setImpersonatedUser(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") loadForEffectiveUser();
              }}
              sx={{ flex: 1, maxWidth: 300 }}
            />
            <Button variant="contained" color="secondary" onClick={loadForEffectiveUser}>
              Cargar
            </Button>
            {impersonatedUser.trim() && (
              <Typography variant="body2" color="warning.main" fontWeight="bold">
                Viendo como: {impersonatedUser.trim()}
              </Typography>
            )}
          </Box>
        )}
        <Box gridColumn={"span 12"}>
          <Box
            display="grid"
            gridTemplateColumns={{
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              lg: "repeat(2, 1fr)",
            }}
            gap="20px"
          >
            <Autocomplete
              sx={{
                gridColumn: { xs: "span 2", sm: "span 1", md: "span 1" },
              }}
              fullWidth
              onChange={(event, newValue) => handleChange(newValue, "service")}
              color="secondary"
              options={tipoServicio}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => (
                <TextField
                  {...params}
                  color="secondary"
                  label="Servicios"
                  variant="filled"
                  name="Servicios"
                />
              )}
            />
            <Autocomplete
              sx={{
                gridColumn: { xs: "span 2", sm: "span 1", md: "span 1" },
              }}
              fullWidth
              onChange={(event, newValue) => handleChange(newValue, "year")}
              color="secondary"
              options={availableYears}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => (
                <TextField {...params} color="secondary" label="Año" variant="filled" name="Servicios" />
              )}
            />
          </Box>
        </Box>
        <Box gridColumn={"span 12"}>
          <Typography variant="h6" fontWeight="bold" mb={1}>
            Lista de Avisos
          </Typography>
          <Box m="5px 0 0 0" height="65vh" sx={dataGridStyles(colors)}>
            <DataGrid
              rows={listaAvisos}
              columns={columnsAvisos}
              loading={loading}
              //components={{ Toolbar: GridToolbar }}
              //onRowClick={(params) => handleRowClick(params)}
            />
          </Box>
        </Box>
        {/* <Box gridColumn={"span 3"}>
          <Typography variant="h6" fontWeight="bold" mb={1}>
            Documentos Adjuntos
          </Typography>
          <Box m="5px 0 0 0" height="65vh" sx={dataGridStyles(colors)}>
            <DataGrid columns={columnsDocumentos} rows={archivos} />
          </Box>
        </Box> */}
      </Box>
    </Box>
  );
};

export default ConsultaAvisos;
